import React from "react";
import "./serviceDM.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import Digital from "../../components/Digital/Digital";

const ServiceDM = () => {
    return (
        <>
            <Topbar />
            <div className="serviceDM-container">
                <Digital/>
                <Footer />
            </div>
        </>
    )
}

export default ServiceDM;